if (!customElements.get('coa-cart-bar')) {
  customElements.define(
    'coa-cart-bar',
    class CoaCartBar extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        this.resizeObserver = new ResizeObserver(() => this.updateReservedSpace());
        this.resizeObserver.observe(this);
        this.updateReservedSpace();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      async refresh() {
        try {
          const response = await fetch(`${routes.cart_url}.json`);
          const cart = await response.json();
          this.render(cart);
        } catch (error) {
          console.error(error);
        }
      }

      render(cart) {
        const contents = this.querySelector('.coa-cart-bar__contents');
        const shipping = this.querySelector('.coa-cart-bar__shipping');
        const progress = this.querySelector('.coa-cart-bar__progress');
        const progressFill = this.querySelector('.coa-cart-bar__progress-fill');
        const count = this.querySelector('[data-cart-bar-count]');
        const countLabel = this.querySelector('[data-cart-bar-count-label]');
        const total = this.querySelector('[data-cart-bar-total]');
        const bottomCartEnabled = this.dataset.bottomCartEnabled === 'true';

        if (!contents) return;

        contents.dataset.cartEmpty = cart.item_count > 0 && (bottomCartEnabled || Number(this.dataset.thresholdCents) > 0) ? 'false' : 'true';
        if (count) count.textContent = cart.item_count;
        if (countLabel) countLabel.textContent = cart.item_count === 1 ? 'Item' : 'Items';
        if (total) total.textContent = this.formatMoney(cart.total_price, cart.currency);
        this.updateReservedSpace();

        const threshold = Number(this.dataset.thresholdCents);
        if (!threshold || !shipping || !progress || !progressFill) {
          this.updateReservedSpace();
          return;
        }

        const currentTotal = Math.min(cart.total_price, threshold);
        const progressPercent = Math.min((cart.total_price / threshold) * 100, 100);
        const shippingText = shipping.querySelector('.coa-cart-bar__shipping-text');

        shipping.classList.remove('hidden');
        progress.classList.toggle('hidden', cart.total_price >= threshold);
        progress.setAttribute('aria-valuemax', threshold);
        progress.setAttribute('aria-valuenow', currentTotal);
        progressFill.style.setProperty('--coa-cart-progress', `${progressPercent}%`);

        if (shippingText) {
          if (cart.total_price < threshold) {
            shippingText.innerHTML = `Add ${this.formatMoney(threshold - cart.total_price, cart.currency)} more for <strong>free shipping</strong>`;
          } else {
            shippingText.innerHTML = 'You qualify for <strong>free shipping</strong>';
          }
        }

        this.updateReservedSpace();
      }

      updateReservedSpace() {
        const contents = this.querySelector('.coa-cart-bar__contents');
        const isVisible = contents?.dataset.cartEmpty === 'false';
        document.body.classList.toggle('coa-cart-bar-visible', isVisible);

        if (!isVisible || !contents) {
          document.documentElement.style.setProperty('--coa-cart-bar-height', '0px');
          return;
        }

        document.documentElement.style.setProperty('--coa-cart-bar-height', `${contents.offsetHeight}px`);
      }

      formatMoney(cents, currency) {
        return new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: currency || this.dataset.currency || 'USD',
        }).format(cents / 100);
      }
    }
  );
}
